import { ReactNode, createContext } from 'react';
import { LocationDetail } from '../types/location/location-detail';
import useCommonData from '../hooks/context/use-common-data';
import { RegionDetail } from '../types/location/region-detail';

export interface CommonDataContextType {
    locations: LocationDetail[];
    regions: RegionDetail[];
}

export const CommonDataContext = createContext<CommonDataContextType>({
    locations: [],
    regions: [],
});

const CommonDataContextProvider = ({ children }: { children: ReactNode }) => {
    const store = useCommonData();
    return <CommonDataContext.Provider value={store}>{children}</CommonDataContext.Provider>;
};

export default CommonDataContextProvider;
